<template>
<div class="chat-contact">
               
  <vue-perfect-scrollbar class="chat-history--scrollbar">
    <v-divider></v-divider>
    <v-list two-line class="chat-contact--list">

      <!-- Table Start -->

      <v-flex lg12 md12>
        <v-toolbar card color="white">
          <v-text-field
          flat
          solo
          prepend-icon="search"
          placeholder="Type something"
          v-model="search"
          hide-details
          class="hidden-sm-and-down"
          ></v-text-field>     
        </v-toolbar>
  
        <v-divider></v-divider>
  
        <v-data-table
          :headers="complex.headers"
          :search="search"
          :items="complex.items"
          :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
          item-key="name"
          v-model="complex.selected"
          >
          <template slot="items" slot-scope="props">
            <td>
              <v-avatar size="32">
                <img :src="props.item.avatar" alt="">
              </v-avatar> 
            </td>
            <td>{{ props.item.uuid }}</td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.jobTitle }}</td>
            <td>{{ props.item.address.zipcode }}</td>
            <td>
              <v-btn depressed outline icon fab dark color="primary" small :to="editPromosi(props.item.uuid)">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn depressed outline icon fab dark color="pink" small @click="deleteItem(props.item.uuid)">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>  

      <!-- Table End -->
      
    </v-list>  
  </vue-perfect-scrollbar>  
</div>
</template>

<script>
import { getUser } from '@/api/user';
import { Items as Users } from '@/api/user';

import VCircle from '@/components/circle/VCircle';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import VWidget from '@/components/VWidget';

export default {
  components: {
    VuePerfectScrollbar,
    VCircle,
    VWidget
  },

  data: () => ({ 
  }),

  data () {
    return {
      search: '',
      complex: {
        headers: [
          {
            text: 'Image',
            value: 'image'
          },
          {
            text: 'ID Promosi',
            value: 'idadmin'
          },
          {
            text: 'Nama Promosi',
            value: 'namaadmin'
          },
          {
            text: 'Tanggal Mulai',
            value: 'keperluan'
          },
          {
            text: 'Tanggal Berakhir',
            value: 'jumlahrupiah'
          },
          {
            text: 'Action',
            value: ''
          },
        ],
        items: Users
      }
    };
  },

  computed: {
    users () {
      return getUser();
    }
  },

  methods: {

    initialize(){
      this.items = Users;
      console.log("Cek Items : ", this.items);
    },

    deleteItem (item) {
      // const index = this.items.indexOf(item);
      console.log("Item Succesfully Deleted");
    },

    contactRoute (id) {
      return '/daftartutor/daftartutoraktif/' + id;
    },

    editPromosi (id) {
      return '/edit-promosi/' + id;
    },

    firstLetter (name) {
      return name.charAt(0);
    },

    userStatusColor (item) {
      return (item.active) ? 'green' : 'grey';
    }    
  }  
};
</script>

<style>

</style>
